import { useEffect } from "react";

import type { BasicQuery } from "@/core/data_sources/services";
import { parseLinkHeader } from "@/core/utils/pagination";
import { Store } from "@/core/data_sources/store";
import { useService } from "@/core/utils/hooks";

import {
  getTemplatePackByQuery,
  getTemplatePacks,
  type TemplatePackDetailQuery,
} from "../services";
import { LibraryTemplatePacksState } from "./state";

import type { LibraryTemplatePacksActions } from "./actions";
import type { LibraryTemplatePacksHooks } from "./hooks";

export class LibraryTemplatePacksStore extends Store<
  LibraryTemplatePacksState,
  LibraryTemplatePacksActions,
  LibraryTemplatePacksHooks
> {
  private static _instance: LibraryTemplatePacksStore;

  static get instance() {
    LibraryTemplatePacksStore._instance =
      LibraryTemplatePacksStore._instance || new LibraryTemplatePacksStore();
    return this._instance;
  }
  constructor() {
    super(
      new LibraryTemplatePacksState(),
      {
        setTemplatePack: (item) => {
          this.state.setTemplatePack(item);
        },
        setTemplatePacks: (list) => {
          this.state.setTemplatePacks(list);
        },
        setCount: (count) => {
          this.state.setCount(count);
        },
      },
      {
        useTemplatePackStoreService: <Q extends BasicQuery>(q: Q) => {
          const { data, error, loading, query, setQuery } = useService(
            getTemplatePacks,
            q,
          );
          useEffect(() => {
            if (error) {
              return;
            }
            if (!loading && data) {
              const pagination = parseLinkHeader(data.header);
              this.state.setTemplatePacks(data?.data ?? []);
              this.state.setCount(pagination.count ?? data?.data?.length ?? 0);
            }
          }, [loading, data, error]);
          return { data, error, loading, query, setQuery };
        },
        useTemplatePackDetailService: <Q extends TemplatePackDetailQuery>(
          q: Q,
        ) => {
          const { data, error, loading, query, setQuery } = useService(
            getTemplatePackByQuery,
            q,
          );
          useEffect(() => {
            if (error) {
              return;
            }
            if (!loading && data) {
              this.state.setTemplatePack(data.data);
            }
          }, [loading, data, error]);
          return { data, error, loading, query, setQuery };
        },
      },
    );
  }
}
